import React from 'react';
import { View } from 'react-native';
import Svg, { ClipPath, G, Defs, Path, Rect } from 'react-native-svg';
import { IconProps } from '@/components/NeolexonIcon/Icons/types';
import colors from '@/config/colors';
import { IS_WEB } from '@/utils/platform';

export const Sentence = ({
  color = colors.primary,
  isInverted = true,
  size = 24,
  style,
  fillColor,
  ...props
}: IconProps & { isInverted?: boolean }) => {
  if (IS_WEB) {
    return (
      <View {...props}>
        <svg width={size} height={size} viewBox="0 0 20 20" fill="none">
          <g clipPath="url(#clip0_3149_43354)">
            <path
              d="M4.16797 8.3335H15.8346M4.16797 11.6668H9.16797"
              stroke={isInverted ? 'white' : color}
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
          <defs>
            <clipPath id="clip0_3149_43354">
              <rect
                width={size}
                height={size}
                fill={isInverted ? color : 'white'}
              />
            </clipPath>
          </defs>
        </svg>
      </View>
    );
  }

  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      style={style}
      {...props}
    >
      <G clipPath="url(#clip0_3149_43354)">
        <Path
          d="M4.16797 8.3335H15.8346M4.16797 11.6668H9.16797"
          stroke={isInverted ? 'white' : color}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_3149_43354">
          <Rect
            width={size}
            height={size}
            fill={isInverted ? color : 'white'}
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
};
